var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-6" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", [_vm._v("First Name")]),
          _vm._v(" "),
          _c("b-form-input", {
            ref: "focusThis",
            attrs: {
              type: "text",
              "lazy-formatter": "",
              formatter: _vm.Format.titleCase
            },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.saveContactFn.apply(null, arguments)
              }
            },
            model: {
              value: _vm.first_name,
              callback: function($$v) {
                _vm.first_name = $$v
              },
              expression: "first_name"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-6" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", [_vm._v("Last Name")]),
          _vm._v(" "),
          _c("b-form-input", {
            attrs: {
              type: "text",
              "lazy-formatter": "",
              formatter: _vm.Format.titleCase
            },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.saveContactFn.apply(null, arguments)
              }
            },
            model: {
              value: _vm.last_name,
              callback: function($$v) {
                _vm.last_name = $$v
              },
              expression: "last_name"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-6" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", [_vm._v("Title")]),
          _vm._v(" "),
          _c("b-form-input", {
            attrs: {
              type: "text",
              "lazy-formatter": "",
              formatter: _vm.Format.titleCase
            },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.saveContactFn.apply(null, arguments)
              }
            },
            model: {
              value: _vm.position,
              callback: function($$v) {
                _vm.position = $$v
              },
              expression: "position"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-6" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", [_vm._v("Company")]),
          _vm._v(" "),
          _c("b-form-input", {
            attrs: { type: "text" },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.saveContactFn.apply(null, arguments)
              }
            },
            model: {
              value: _vm.company_name,
              callback: function($$v) {
                _vm.company_name = $$v
              },
              expression: "company_name"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-6" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", [_vm._v("Email")]),
          _vm._v(" "),
          _c("b-form-input", {
            attrs: {
              type: "text",
              "lazy-formatter": "",
              formatter: _vm.Format.email
            },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.saveContactFn.apply(null, arguments)
              }
            },
            model: {
              value: _vm.email_address,
              callback: function($$v) {
                _vm.email_address = $$v
              },
              expression: "email_address"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-6" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", [_vm._v("Phone")]),
          _vm._v(" "),
          _c("b-form-input", {
            attrs: {
              type: "text",
              "lazy-formatter": "",
              formatter: _vm.Format.phone
            },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.saveContactFn.apply(null, arguments)
              }
            },
            model: {
              value: _vm.phone,
              callback: function($$v) {
                _vm.phone = $$v
              },
              expression: "phone"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "form-group" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button", "data-dismiss": "modal" },
            on: { click: _vm.saveContactFn }
          },
          [_vm._v("Add")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }